import { mergeSx, Stack } from '@cast/design-system';

import type { StackProps } from '@cast/design-system';

export const StepContainer = ({ sx, ...props }: StackProps) => (
  <Stack sx={mergeSx({ overflow: 'hidden', height: '100%' }, sx)} {...props} />
);
